module.exports = __webpack_public_path__ + "img/delicious-preservative-foods-1@1x.39e324e5.png";